<div class="popup">
    <div class="section">
        <div class="header">
            <div class="label">
                Create Consolidated Invoice
            </div>
            <div style="display: flex;gap: 24px;align-items: center;">
                <div class="inputRow">
                    <div class="label">
                        Plant Code: {{plantCode}}
                    </div>
                </div>
                <div class="close">
                    <button mat-icon-button class="close-button" [mat-dialog-close]="true">
                        <img src="assets/popup_close_icon.svg" alt="">
                    </button>
                </div>
            </div>
        
        </div>
        <div class="body">
            <div class="table">
                <div class="tableHeader">
                    <div class="label">
                        Invoices
                    </div>
                </div>
                <div class="tableBody">
                <table mat-table [dataSource]="dataSource">
                
                    <!-- Sno Column -->
                    <ng-container matColumnDef="sno">
                        <th mat-header-cell *matHeaderCellDef>S.No.</th>
                        <td mat-cell *matCellDef="let element">{{element.sno}}</td>
                    </ng-container>

                    <!-- Trip Id column -->
                    <ng-container matColumnDef="sin">
                        <th mat-header-cell *matHeaderCellDef>SIN</th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.toolTipText">{{element.sin}}</td>
                    </ng-container>
                
                    <!-- Invoice Column -->
                    <ng-container matColumnDef="invoice">
                        <th mat-header-cell *matHeaderCellDef>Invoice | OD Number</th>
                        <td mat-cell *matCellDef="let element">{{ element.invoice ? element.invoice : '-' }} | {{ element.odNumber ? element.odNumber : '-' }}</td>
                    </ng-container>


                    <!-- <ng-container matColumnDef="carrierInvoice">
                        <th mat-header-cell *matHeaderCellDef>Carrier Invoice</th>
                        <td mat-cell *matCellDef="let element">
                            <input type="text" [(ngModel)]="element.carrierInvoice">
                        </td>
                    </ng-container> -->
                
                    <!-- OD number Column -->
                    <ng-container matColumnDef="odNumber">
                        <th mat-header-cell *matHeaderCellDef>OD number</th>
                        <td mat-cell *matCellDef="let element">{{element.odNumber}}</td>
                    </ng-container>
                
                    <!-- chargeWeight Column -->
                    <ng-container matColumnDef="chargeWeight">
                        <th mat-header-cell *matHeaderCellDef>Charge Weight (MT)</th>
                        <td mat-cell *matCellDef="let element">{{element.chargeWeight}}</td>
                    </ng-container>
                
                    <!-- Freight Rate Column -->
                    <ng-container matColumnDef="freightRate">
                        <th mat-header-cell *matHeaderCellDef>Freight Rate (&#8377;)</th>
                        <td mat-cell *matCellDef="let element">{{element.freightRate | numberFormat}}</td>
                    </ng-container>
                
                    <!-- Freight Amount Column -->
                    <ng-container matColumnDef="freightAmount">
                        <th mat-header-cell *matHeaderCellDef>Freight Amount (&#8377;)</th>
                        <td mat-cell *matCellDef="let element">{{element.freightAmount | numberFormat}}</td>
                    </ng-container>

                    <!-- RTO Amount Column -->
                    <ng-container matColumnDef="rtoWeight">
                        <th mat-header-cell *matHeaderCellDef>RTO Weight</th>
                        <td mat-cell *matCellDef="let element">
                            {{element.rtoWeight}}
                        </td>
                    </ng-container>

                    <!-- Weight Extra Column -->
                    <ng-container matColumnDef="weightExtra">
                        <th mat-header-cell *matHeaderCellDef>Weight Extra Amount (&#8377;)</th>
                        <td mat-cell *matCellDef="let element">{{element.weightExtra | numberFormat}}</td>
                    </ng-container>
                
                    <!-- SAP weight Column -->
                    <ng-container matColumnDef="sapWeight">
                        <th mat-header-cell *matHeaderCellDef>Sap Weight (&#8377;)</th>
                        <td mat-cell *matCellDef="let element">{{element.sapWeight}}</td>
                    </ng-container>


                    <!-- Material rate Column -->
                    <ng-container matColumnDef="materialRate">
                        <th mat-header-cell *matHeaderCellDef>Material Rate (&#8377;)</th>
                        <td mat-cell *matCellDef="let element">{{element.materialRate | numberFormat}}</td>
                    </ng-container>

                    <!-- RTO Amount Column -->
                    <ng-container matColumnDef="rtoAmount">
                        <th mat-header-cell *matHeaderCellDef>RTO Amount (&#8377;)</th>
                        <td mat-cell *matCellDef="let element">
                            <input type="number" [disabled]="!element.odc" [(ngModel)]="element.rtoAmount" (keyup)="calculateTotal()">
                        </td>
                    </ng-container>

                    <!-- Shortage Column -->

                    

                    <ng-container matColumnDef="detentionCharges">
                        <th mat-header-cell *matHeaderCellDef>Detention Charges (&#8377;)</th>
                        <td mat-cell *matCellDef="let element">
                            <input type="number" [disabled]="!element.first" [(ngModel)]="element.detentionCharges" (keyup)="calculateTotal()">
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="incentives">
                        <th mat-header-cell *matHeaderCellDef>Add. Charges (&#8377;)</th>
                        <td mat-cell *matCellDef="let element">
                            <input type="number" [disabled]="!element.first" [(ngModel)]="element.incentives" (keyup)="calculateTotal()" min="0">
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="remarks">
                        <th mat-header-cell *matHeaderCellDef>Add. Chg Remark</th>
                        <td mat-cell *matCellDef="let element">
                            <div style="display: flex; flex-direction: column; align-items: flex-start; position: relative;box-sizing: border-box;">
                                <div style="display: flex; align-items: center; gap: 8px; width: 100%;">
                                    <input type="text"
                                           [disabled]="!element.first || element.incentives === 0"
                                           [ngModel]="element.remarks"
                                           (ngModelChange)="onRemarksChange(element, $event)"
                                           [required]="element.incentives > 0"
                                           style="flex-grow: 1; width: 100%; box-sizing: border-box;"
                                    >
                                    <mat-icon *ngIf="element.incentives > 0 && !element.remarks && !element.remarksErrorMessage" class="alert-icon" style="color: red;" matTooltip="Remarks are required when Add. Charges > 0">
                                        error_outline
                                    </mat-icon>
                                </div>
                                <!-- <div *ngIf="element.remarksErrorMessage" 
                                     style="color: red; font-size: 12px; position: absolute; bottom: -14px; left: 1px; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; line-height: 16px;"
                                     [matTooltip]="element.remarksErrorMessage"
                                     matTooltipPosition="below">
                                    {{ element.remarksErrorMessage }}
                                </div> -->
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="attachments">
                        <th mat-header-cell *matHeaderCellDef>Add. Chg Attachment</th>
                        <td mat-cell *matCellDef="let element">
                            <div style="display: flex; align-items: center; gap: 8px;">
                                <div class="epods" [class.disabled-upload]="!element.first || element.incentives === 0">
                                    <div class="count" (click)="!(!element.first || element.incentives === 0) && downloadAdditionalCharge(element.attachments)" 
                                        title="Download Attachments">
                                        {{element.attachments?.length || 0}}
                                    </div>
                                    <div class="upload" (click)="!(!element.first || element.incentives === 0) && openAdditionalChargeAttachment(element)" 
                                        title="Upload Attachment">
                                        <mat-icon class="more-icon">upload_file</mat-icon>
                                    </div>
                                </div>
                                <mat-icon *ngIf="element.incentives > 0 && (!element.attachments || element.attachments.length === 0)" 
                                        class="alert-icon" style="color: red;" matTooltip="Add. Chg Attachment are required when Add. Charges > 0">
                                    error_outline
                                </mat-icon>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="OdcCharges">
                        <th mat-header-cell *matHeaderCellDef>ODC UOM Charges (Per MT)</th>
                        <td mat-cell *matCellDef="let element">
                            <input type="number" [disabled]="!element.odc" [(ngModel)]="element.odc_charge_uom" (keyup)="calculateTotal()">
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="epods">
                        <th mat-header-cell *matHeaderCellDef>ePOD</th>
                        <td mat-cell *matCellDef="let element">
                            <div style="display: flex; align-items: center; gap: 8px;">
                                <div class="epods">
                                    <div class="count" (click)="downloadEpods(element.epods)" title="Download ePOD">
                                        {{element.epods.length}}
                                    </div>
                                    <div class="upload" (click)="openFileUploader(element)" title="Upload ePOD">
                                        <mat-icon class="more-icon">upload_file</mat-icon>
                                    </div>
                                </div>
                                <mat-icon *ngIf="element.epods.length === 0" class="alert-icon" style="color: red;">
                                    error_outline
                                </mat-icon>
                            </div>
                        </td>
                    </ng-container>
                
                    <!-- Define table columns -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'row-error': row.rowError}"></tr>
                </table>
                </div>

            </div>
            <div class="table">
                <div class="tableHeader">
                    <div class="label">
                        Extra Charges
                    </div>
                </div>
                <div class="tableBody">
                    <table mat-table [dataSource]="dataSource">
            
                        <!-- Sno Column -->
                        <ng-container matColumnDef="sno">
                            <th mat-header-cell *matHeaderCellDef>S.No.</th>
                            <td mat-cell *matCellDef="let element">{{element.sno}}</td>
                        </ng-container>
            
                        <!-- Trip Id column -->
                        <ng-container matColumnDef="sin">
                            <th mat-header-cell *matHeaderCellDef>SIN</th>
                            <td mat-cell *matCellDef="let element" >{{element.sin}}</td>
                        </ng-container>
            
                        <!-- Invoice Column -->
                        <ng-container matColumnDef="invoice">
                            <th mat-header-cell *matHeaderCellDef>Invoice</th>
                            <td mat-cell *matCellDef="let element">{{element.invoice}}</td>
                        </ng-container>
            
                        <!-- OD number Column -->
                        <ng-container matColumnDef="rtoCharges">
                            <th mat-header-cell *matHeaderCellDef>RTO Amount (&#8377;)</th>
                            <td mat-cell *matCellDef="let element">{{(element.rtoAmount || 0) | numberFormat}}</td>
                        </ng-container>
            
                        <!-- chargeWeight Column -->
                        <ng-container matColumnDef="mwg">
                            <th mat-header-cell *matHeaderCellDef >MWG - A (&#8377;)</th>
                            <td mat-cell *matCellDef="let element" [matTooltip]="'Extra weight (' + element.weight_extra + ') * freight rate (' + element.freightRate + ')'">{{element.mwg | numberFormat}}</td>
                        </ng-container>
            
                        <!-- Freight Rate Column -->
                        <ng-container matColumnDef="multipleUnloadingPoint">
                            <th mat-header-cell *matHeaderCellDef>Multiple Unloading Point (&#8377;)</th>
                            <td mat-cell *matCellDef="let element">{{element.multipleUnloadingPoint | numberFormat}} <img style="width: 16px; position: relative; top: 3px; cursor: pointer;" (click)="element.multipleUnloadingPoint = 0; updatingMultipleUnloading(element)" src="assets/icon-cancel-red.svg" alt="" class="icon" /></td>
                        </ng-container>
                        <ng-container matColumnDef="multipleLoadingPoint">
                            <th mat-header-cell *matHeaderCellDef>Multiple Loading Point (&#8377;)</th>
                            <td mat-cell *matCellDef="let element">{{element.multipleLoadingPoint | numberFormat}} <img style="width: 16px; position: relative; top: 3px; cursor: pointer;" (click)="element.multipleLoadingPoint = 0; updatingMultipleloading(element)" src="assets/icon-cancel-red.svg" alt="" class="icon" /></td>
                        </ng-container>
            
                        <!-- Freight Amount Column -->
                        <ng-container matColumnDef="detentionCharges">
                            <th mat-header-cell *matHeaderCellDef>Detention Charges (&#8377;)</th>
                            <td mat-cell *matCellDef="let element">{{(element.detentionCharges || 0) | numberFormat}}</td>
                        </ng-container>

                        <ng-container matColumnDef="incentives">
                            <th mat-header-cell *matHeaderCellDef>Add. Charges (&#8377;)</th>
                            <td mat-cell *matCellDef="let element">{{(element.incentives || 0) | numberFormat}}</td>
                        </ng-container>
                        <ng-container matColumnDef="odcCharges">
                            <th mat-header-cell *matHeaderCellDef>ODC Charges</th>
                            <td mat-cell *matCellDef="let element" [matTooltip]="(element.vehicle_capacity > element.invoiceWeight ? 'Vehicle Capacity (' : 'Charge Weight (') + (element.vehicle_capacity > element.invoiceWeight ? element.vehicle_capacity : element.invoiceWeight) + ') * ODC UOM Charges (' + element.odc_charge_uom + ')'">
                                <!-- {{element.odcCharges | numberFormat}} -->
                                {{((element.vehicle_capacity > element.invoiceWeight ? element.vehicle_capacity: element.invoiceWeight)*element.odc_charge_uom).toFixed(2)}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="theoretical_extra_charges">
                            <th mat-header-cell *matHeaderCellDef>Theoretical Extra Charges</th>
                            <td mat-cell *matCellDef="let element" [matTooltip]="(element.theoreticalWeight < 0 && (element.odc_charge_uom && element.odc_charge_uom > 0))
  ? ('Theoretical weight (' + element.theoreticalWeight.toFixed(3) + ') * (ODC charges UOM (' + (element.odc_charge_uom || 0) + ') + Freight rate (' + (element.final_freight_rate || 0) + ')')
  : ('Freight rate (' + (element.final_freight_rate || 0) + ') * Theoretical weight (' + element.theoreticalWeight.toFixed(3) + ')')">
                                <span>{{((element.theoreticalWeight < 0 && element.odc_charge_uom > 0) ? element.theoreticalWeight * (element.odc_charge_uom + element.final_freight_rate) : (element.extra_charges)).toFixed(2)}}</span>
                            </td>
                        </ng-container>

            
                       
                        <!-- Define table columns -->
                        <tr mat-header-row *matHeaderRowDef="displayedColumnsForExtraCharges"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsForExtraCharges;"></tr>
                    </table>
                </div>
            
            </div>

            <div class="table">
                <div class="tableHeader">
                    <div class="label">
                        Shortage Deductions
                    </div>
                </div>
                <div class="tableBody">
                    <table mat-table [dataSource]="dataSource">
            
                        <!-- Sno Column -->
                        <ng-container matColumnDef="sno">
                            <th mat-header-cell *matHeaderCellDef>S.No.</th>
                            <td mat-cell *matCellDef="let element">{{element.sno}}</td>
                        </ng-container>
            
                        <!-- Trip Id column -->
                        <ng-container matColumnDef="sin">
                            <th mat-header-cell *matHeaderCellDef>SIN</th>
                            <td mat-cell *matCellDef="let element">{{element.sin}}</td>
                        </ng-container>
            
                        <!-- Invoice Column -->
                        <ng-container matColumnDef="invoice">
                            <th mat-header-cell *matHeaderCellDef>Invoice</th>
                            <td mat-cell *matCellDef="let element">{{element.invoice}}</td>
                        </ng-container>
            
                        <ng-container matColumnDef="deductions">
                            <th mat-header-cell *matHeaderCellDef>Deductions (&#8377;)</th>
                            <td mat-cell *matCellDef="let element">
                                <span [matTooltip]="'Shortage (' + element.shortage + ') * Material Rate (' + element.materialRate + ')'">{{element.deductions | numberFormat}}</span>
                            </td>
                        </ng-container>
            
            
                        <!-- Define table columns -->
                        <tr mat-header-row *matHeaderRowDef="displayedColumnsForDeductions"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsForDeductions;"></tr>
                    </table>
                </div>
            
            </div>
            

            
            
            <div class="inputRow">
                <div class="label">
                    Total: &#8377; {{totalAmount | numberFormat }}
                </div>
            </div>
            <div class="inputRow">
                <mat-radio-group aria-label="Select an option" [(ngModel)]="taxDetails" class="radioButtons">
                    <mat-radio-button value="1">CGST/SGST</mat-radio-button>
                    <mat-radio-button value="2">IGST</mat-radio-button>
                </mat-radio-group>
                <div class="input">
                    <input type="text" [(ngModel)]="tds" placeholder="TDS (%)">
                </div>
                <div class="input">
                    <input type="text" class="inputField" placeholder="Date"
                        [(ngModel)]="date" (click)="fromDateInput.open()" [matDatepicker]="fromDateInput" />
                    <mat-datepicker #fromDateInput></mat-datepicker>
                </div>
                <div class="input">
                    <input type="text" [(ngModel)]="carrierInvoiceNumber" placeholder="Invoice Number">
                </div>
                <div class="input">
                    <input type="text" [(ngModel)]="comments" placeholder="Comments">
                </div>
            </div>
            
            <div class="wrap">
                <div class="wrap-button">
                    <div class="buttons">
                        <div class="newButton" (click)="openFileUploaderInvoice('invoice_attachment')">
                            <div class="label">Upload Attachment</div>
                        </div>
                    </div>
                    <div class="buttons" *ngIf="enableButton">
                        <div class="newButton" (click)="createConsolidatedInvoice()">
                            <div class="label">Create Invoice</div>
                        </div>
                    </div>
                    <div class="buttons" *ngIf="!enableButton">
                        <div class="newButton">
                            <div class="label">Create Invoice</div>
                        </div>
                    </div>
                </div>
                <div class="note">
                    *Note: Please upload your Invoice copy, RTO bills, MWG approval documents and any other related documents in PDF format.
                </div>
            </div>
            
        </div>
        
    </div>
</div>
